import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../core';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';

import { UsuarioModel } from 'src/app/modelo/usuario.model';
import { TareaModel } from '../modelo/Tarea.model';
import { PerfilModel } from '../modelo/Perfil.model';
import { EliminarData } from '../modelo/EliminarData';
import { Reporte } from '../modelo/Reporte';
import { CatalogoModel } from '../modelo/Catalogo.model';
import { Plan } from '../modelo/Plan';
import { PlanOrganizacion } from '../modelo/PlanOrganizacion';
import { FiltrosData } from '../modelo/FiltrosData';
import { DashboardIndicador } from '../modelo/DashboardIndicador';


@Injectable({
    providedIn: 'root'
})
export class AdministracionService {

    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private apiService: ApiService,
        httpErrorHandler: HttpErrorHandler
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('AdministracionService');
    }

    /*************************************************************************************
    **ReporteController
    **************************************************************************************/
    /**
    **Reporte
    **/
    async getReportesActivosData(): Promise<any> {
        return this.getReportesActivos().toPromise();
    }
    getReportesActivos() {
        return this.apiService.get(this.apiServer + '/reporte')
            .pipe(
                catchError(this.handleError('AdministracionService.getReportesActivos'))
            )
    }

    async getReportesPorModuloData(routerLink: string): Promise<any> {
        return this.getReportesPorModulo(routerLink).toPromise();
    }
    getReportesPorModulo(routerLink: string) {
        //let routerLink2 = routerLink.replace("/", ":");
        let re = /\//gi;
        let routerLink2 = routerLink.replace(re, ":");
        return this.apiService.get(this.apiServer + '/reporte/tipo/' + routerLink2)
            .pipe(
                catchError(this.handleError('AdministracionService.getReportesPorModulo'))
            )
    }

    async getReportesPorModuloClaseData(routerLink: string, clase: string): Promise<any> {
        return this.getReportesPorModuloClase(routerLink, clase).toPromise();
    }
    getReportesPorModuloClase(routerLink: string, clase: string) {
        //let routerLink2 = routerLink.replace("/", ":");
        let re = /\//gi;
        let routerLink2 = routerLink.replace(re, ":");
        
        console.log('reports::', routerLink2);
        return this.apiService.get(this.apiServer + '/reporte/tipo/' + routerLink2 + '/clase/' + clase)
            .pipe(
                catchError(this.handleError('AdministracionService.getReportesPorModuloClase'))
            )
    }

    async getReporteData(uuid): Promise<any> {
        return this.getReporte(uuid).toPromise();
    }
    getReporte(uuid: string) {
        return this.apiService.get(this.apiServer + '/reporte/' + uuid + '')
            .pipe(
                catchError(this.handleError('AdministracionService.getReporte'))
            )
    }

    guardarReporte(reporte: Reporte): Observable<Reporte> {
        if (reporte.id && reporte.uuid) {
            return this.apiService.put(this.apiServer + '/reporte', reporte)
                .pipe(map(data => data['reporte']));
        } else {
            return this.apiService.post(this.apiServer + '/reporte', reporte)
                .pipe(map(data => data['reporte']));
        }
    }

    borrarReporte(uuid: string): Observable<Reporte> {
        return this.apiService.delete(this.apiServer + '/reporte/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarReporte', uuid)))
    }

    borrarReportes(eliminarData: EliminarData): Observable<Reporte> {
        return this.apiService.put(this.apiServer + '/reporte/seleccionados', eliminarData)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarReportes'))
            )
    }


    generarReporte(uuid: string, data: any) {
        if (uuid) {
            return this.apiService.downloadFileFromPost(`${this.apiServer}/reporte/${uuid}/download`, data).pipe(
                catchError(this.handleError('AdministracionService::generarReporte', uuid))
            );;
        }
    }

    generarReportePorFiltros(uuid: string, filtrosData: FiltrosData) {
        if (uuid) {
            return this.apiService.downloadFileFromPost(`${this.apiServer}/reporte/${uuid}/filtros/download`, filtrosData).pipe(
                catchError(this.handleError('AdministracionService::generarReportePorFiltros', uuid))
            );;
        }
    }

    /*************************************************************************************
    **CatalogoController
    **************************************************************************************/
    /**
    **Catalogo
    **/
    async getCatalogosActivosData(): Promise<any> {
        return this.getCatalogosActivos().toPromise();
    }
    getCatalogosActivos() {
        return this.apiService.get(this.apiServer + '/catalogos')
            .pipe(
                catchError(this.handleError('AdministracionService.getCatalogosActivos'))
            )
    }

    async getCatalogosArbolData(): Promise<any> {
        return this.getCatalogosArbol().then();
    }
    getCatalogosArbol() {
        return this.apiService.get(this.apiServer + '/catalogos/arbol')
            .toPromise()
            .then(data => <TreeNode[]>data['data']);
    }

    async getCatalogosRaicesData(): Promise<any> {
        return this.getCatalogosRaices().toPromise();
    }
    getCatalogosRaices() {
        return this.apiService.get(this.apiServer + '/catalogos/raices')
            .pipe(
                catchError(this.handleError('AdministracionService.getCatalogosRaices'))
            )
    }

    async getCatalogoData(uuid): Promise<any> {
        return this.getCatalogo(uuid).toPromise();
    }
    getCatalogo(uuid: string) {
        return this.apiService.get(this.apiServer + '/catalogos/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.getCatalogo'))
            )
    }

    async getCatalogosPorCatalogoCodigoData(codigo: string): Promise<any> {
        return this.getCatalogosPorCatalogoCodigo(codigo).toPromise();
    }
    getCatalogosPorCatalogoCodigo(codigo: string) {
        return this.apiService.get(this.apiServer + '/catalogos/' + codigo + '/hijos')
            .pipe(
                catchError(this.handleError('AdministracionService.getCatalogosPorCatalogoCodigo'))
            )
    }

    guardarCatalogo(catalogo: CatalogoModel): Observable<CatalogoModel> {
        if (catalogo.id && catalogo.uuid) {
            return this.apiService.put(this.apiServer + '/catalogos', catalogo)
                .pipe(map(data => data['catalogo']));
        } else {
            return this.apiService.post(this.apiServer + '/catalogos', catalogo)
                .pipe(map(data => data['catalogo']));
        }
    }

    borrarCatalogo(uuid: string): Observable<CatalogoModel> {
        return this.apiService.delete(this.apiServer + '/catalogos/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarCatalogo', uuid)))
    }

    borrarCatalogos(eliminarData: EliminarData): Observable<TareaModel[]> {
        return this.apiService.put(this.apiServer + '/catalogos/seleccionados', eliminarData)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarCatalogos'))
            )
    }

    /*************************************************************************************
    **UsersController
    **************************************************************************************/
    /**
    **Subject => Usuario
    **/
    async getUsuariosData(): Promise<any> {
        return this.getUsuarios().toPromise();
    }
    getUsuarios() {
        return this.apiService.get(this.apiServer + '/users')
            .pipe(
                catchError(this.handleError('AdministracionService.getUsuarios'))
            )
    }

    async getUsuariosNoTemporalesData(): Promise<any> {
        return this.getUsuariosNoTemporales().toPromise();
    }
    getUsuariosNoTemporales() {
        return this.apiService.get(this.apiServer + '/users/notemporales')
            .pipe(
                catchError(this.handleError('AdministracionService.getUsuariosNoTemporales'))
            )
    }

    async getUsuarioModelData(uuid): Promise<any> {
        return this.getUsuarioModel(uuid).toPromise();
    }
    getUsuarioModel(uuid: string) {
        return this.apiService.get(this.apiServer + '/users/usuario/' + uuid + '')
            .pipe(
                catchError(this.handleError('AdministracionService.getUsuarioModel'))
            )
    }

    async getUsuarioData(uuid): Promise<any> {
        return this.getUsuario(uuid).toPromise();
    }
    getUsuario(uuid: string) {
        return this.apiService.get(this.apiServer + '/users/' + uuid + '')
            .pipe(
                catchError(this.handleError('AdministracionService.getUsuario'))
            )
    }

    async getUsuarioPorCodigoData(codigo: string): Promise<any> {
        return this.getUsuarioPorCodigo(codigo).toPromise();
    }
    getUsuarioPorCodigo(codigo: string) {
        return this.apiService.get(this.apiServer + '/users/codigo/' + codigo + '')
            .pipe(
                catchError(this.handleError('AdministracionService.getUsuarioPorCodigo'))
            )
    }

    async getUserPorCodeData(code: string): Promise<any> {
        return this.getUserPorCode(code).toPromise();
    }
    getUserPorCode(code: string) {
        return this.apiService.get(this.apiServer + '/users/code/' + code + '')
            .pipe(
                catchError(this.handleError('PerfilService.getUserPorCode'))
            )
    }

    async getEmailPorCodeData(code: string): Promise<any> {
        return this.getEmailPorCode(code).toPromise();
    }
    getEmailPorCode(code: string) {
        return this.apiService.get(this.apiServer + '/users/email/' + code + '')
            .pipe(
                catchError(this.handleError('PerfilService.getEmailByCode'))
            )
    }

    guardarUsuario(usuarioModel: UsuarioModel): Observable<UsuarioModel> {
        if (usuarioModel.id && usuarioModel.uuid) {
            return this.apiService.put(this.apiServer + '/users', usuarioModel)
                .pipe(map(data => data['user']));
        } else {
            return this.apiService.post(this.apiServer + '/users', usuarioModel)
                .pipe(map(data => data['user']));
        }
    }

    borrarUsuario(uuid: string): Observable<UsuarioModel> {
        return this.apiService.delete(this.apiServer + '/users/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarUsuario', uuid)))
    }

    /*************************************************************************************
    **TareaController
    **************************************************************************************/
    /**
    **Tarea
    **/
    async getTareasModulosData(): Promise<any> {
        return this.getTareasModulos().toPromise();
    }
    getTareasModulos() {
        return this.apiService.get(this.apiServer + '/tareas/modulos')
            .pipe(
                catchError(this.handleError('AdministracionService.getTareasModulos'))
            );
    }

    async getTareasData(): Promise<any> {
        return this.getTareas().toPromise();
    }
    getTareas() {
        return this.apiService.get(this.apiServer + '/tareas/todos')
            .pipe(
                catchError(this.handleError('AdministracionService.getTareas'))
            );
    }

    async getTareasAsignablesData(): Promise<any> {
        return this.getTareasAsignables().toPromise();
    }
    getTareasAsignables() {
        return this.apiService.get(this.apiServer + '/tareas/asignables')
            .pipe(
                catchError(this.handleError('AdministracionService.getTareasAsignables'))
            );
    }

    async getTareasArbolSimpleData(): Promise<any> {
        return this.getTareasArbolSimple().then();
    }
    getTareasArbolSimple() {
        return this.apiService.get(this.apiServer + '/tareas/arbolsimple')
            .toPromise()
            .then(data => <TreeNode[]>data['data']);
    }

    async getTareasArbolData(): Promise<any> {
        return this.getTareasArbol().then();
    }
    getTareasArbol() {
        return this.apiService.get(this.apiServer + '/tareas/arbol')
            .toPromise()
            .then(data => <TreeNode[]>data['data']);
    }

    async getTareaData(uuid): Promise<any> {
        return this.getTarea(uuid).toPromise();
    }
    getTarea(uuid: string) {
        return this.apiService.get(this.apiServer + '/tareas/' + uuid + '')
            .pipe(
                catchError(this.handleError('AdministracionService.getTarea'))
            )
    }

    guardarTarea(tareaModel: TareaModel): Observable<TareaModel> {
        if (tareaModel.id && tareaModel.uuid) {
            return this.apiService.put(this.apiServer + '/tareas', tareaModel)
                .pipe(map(data => data['tarea']));
        } else {
            return this.apiService.post(this.apiServer + '/tareas', tareaModel)
                .pipe(map(data => data['tarea']));
        }
    }

    borrarTarea(uuid: string): Observable<TareaModel> {
        return this.apiService.delete(this.apiServer + '/tareas/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarTarea', uuid)))
    }

    borrarTareas(eliminarData: EliminarData): Observable<TareaModel[]> {
        return this.apiService.put(this.apiServer + '/tareas/seleccionadas', eliminarData)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarTareas'))
            )
    }

    /*************************************************************************************
    **PerfilController
    **************************************************************************************/
    /**
    **Perfil
    **/
    async getPerfilesData(): Promise<any> {
        return this.getPerfiles().toPromise();
    }
    getPerfiles() {
        return this.apiService.get(this.apiServer + '/perfiles')
            .pipe(
                catchError(this.handleError('AdministracionService.getPerfiles'))
            );
    }

    async getPerfilData(uuid): Promise<any> {
        return this.getPerfil(uuid).toPromise();
    }
    getPerfil(uuid: string) {
        return this.apiService.get(this.apiServer + '/perfiles/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.getPerfil'))
            )
    }

    guardarPerfil(perfilModel: PerfilModel): Observable<PerfilModel> {
        if (perfilModel.id && perfilModel.uuid) {
            return this.apiService.put(this.apiServer + '/perfiles', perfilModel)
                .pipe(map(data => data['perfil']));
        } else {
            return this.apiService.post(this.apiServer + '/perfiles', perfilModel)
                .pipe(map(data => data['perfil']));
        }
    }

    borrarPerfil(uuid: string): Observable<PerfilModel> {
        return this.apiService.delete(this.apiServer + '/perfiles/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarPerfil', uuid)))
    }

    borrarPerfiles(eliminarData: EliminarData): Observable<PerfilModel[]> {
        return this.apiService.put(this.apiServer + '/perfiles/seleccionados', eliminarData)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarPerfiles'))
            )
    }

    async getUsuarioPerfilesData(usuarioId: number): Promise<any> {
        return this.getUsuarioPerfiles(usuarioId).toPromise();
    }
    getUsuarioPerfiles(userId: number) {
        return this.apiService.get(this.apiServer + '/users/' + userId + '/perfiles')
            .pipe(
                catchError(this.handleError('AdministracionService.getUsuarioPerfiles'))
            );
    }

    guardarUsuarioPrivilegios(usuarioPerfiles: any): Observable<UsuarioModel> {
        if (usuarioPerfiles.uuid && usuarioPerfiles.perfiles) {
            return this.apiService.put(this.apiServer + '/users/perfiles', usuarioPerfiles)
                .pipe(map(data => data['user']));
        }
    }

    async getPerfilTareaPorPerfilData(perfilId: number): Promise<any> {
        return this.getPerfilTareaPorPerfil(perfilId).toPromise();
    }
    getPerfilTareaPorPerfil(perfilId: number) {
        return this.apiService.get(this.apiServer + '/perfiles/' + perfilId + '/perfiltareas')
            .pipe(
                catchError(this.handleError('AdministracionService.getPerfilTareaPorPerfil'))
            );
    }

    async getPerfilTareasData(perfilId: number): Promise<any> {
        return this.getPerfilTareas(perfilId).toPromise();
    }
    getPerfilTareas(perfilId: number) {
        return this.apiService.get(this.apiServer + '/perfiles/' + perfilId + '/tareas')
            .pipe(
                catchError(this.handleError('AdministracionService.getPerfilTareas'))
            );
    }

    guardarPerfilTareas(pefilTareas: any): Observable<UsuarioModel> {
        if (pefilTareas.uuid && pefilTareas.tareas) {
            return this.apiService.put(this.apiServer + '/perfiles/tareas', pefilTareas)
                .pipe(map(data => data['perfil']));
        }
    }

    /*************************************************************************************
    **PlanController
    **************************************************************************************/
    /**
    **Plan
    **/
    async getPlanesData(): Promise<any> {
        return this.getPlanes().toPromise();
    }
    getPlanes() {
        return this.apiService.get(this.apiServer + '/planes')
            .pipe(
                catchError(this.handleError('AdministracionService.getPlanes'))
            )
    }

    enviarPlan(plan: Plan) {
        if (plan.id && plan.uuid) {
            return this.apiService.put(this.apiServer + '/planes', plan)
                .pipe(map(data => data['plan']));
        } else {
            return this.apiService.post(this.apiServer + '/planes', plan)
                .pipe(map(data => data['plan']));
        }
    }

    eliminarPlan(uuid: string) {
        return this.apiService.delete(this.apiServer + '/planes/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.eliminarPlan'))
            );
    }

    /*************************************************************************************
    **PlanOrganizacionController
    **************************************************************************************/
    /**
    **PlanOrganizacion
    **/
    async getPlanesOrganizacionData(): Promise<any> {
        return this.getPlanesOrganizacion().toPromise();
    }
    getPlanesOrganizacion() {
        return this.apiService.get(this.apiServer + '/planesorganizacion')
            .pipe(
                catchError(this.handleError('AdministracionService.getPlanesOrganizacion'))
            )
    }
    
    async getPlanesOrganizacionPorRUCData(ruc: string): Promise<any> {
        return this.getPlanesOrganizacionPorRUC(ruc).toPromise();
    }
    getPlanesOrganizacionPorRUC(ruc: string) {
        return this.apiService.get(this.apiServer + '/planesorganizacion/ruc/' + ruc)
            .pipe(
                catchError(this.handleError('AdministracionService.getPlanOrganizacion'))
            )
    }

    async getPlanOrganizacionData(planOrganizacionId: number): Promise<any> {
        return this.getPlanOrganizacion(planOrganizacionId).toPromise();
    }
    getPlanOrganizacion(planOrganizacionId: number) {
        return this.apiService.get(this.apiServer + '/planesorganizacion/' + planOrganizacionId)
            .pipe(
                catchError(this.handleError('AdministracionService.getPlanOrganizacion'))
            )
    }

    async getPlanesOrganizacionPorOrganizacionData(): Promise<any> {
        return this.getPlanesOrganizacionPorOrganizacion().toPromise();
    }
    getPlanesOrganizacionPorOrganizacion() {
        return this.apiService.get(this.apiServer + '/planesorganizacion/organizacion')
            .pipe(
                catchError(this.handleError('AdministracionService.getPlanesOrganizacionPorOrganizacion'))
            )
    }

    enviarPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        if (planOrganizacion.uuid && planOrganizacion.id) {
            return this.apiService.put(this.apiServer + '/planesorganizacion', planOrganizacion)
                .pipe(map(data => data['planOrganizacion']));
        } else {
            return this.apiService.post(this.apiServer + '/planesorganizacion', planOrganizacion)
                .pipe(map(data => data['planOrganizacion']));
        }
    }

    renovarPlanOrganizacion(planOrganizacion: PlanOrganizacion) {
        return this.apiService.post(this.apiServer + '/planesorganizacion', planOrganizacion)
            .pipe(map(data => data['planOrganizacion']));
    }

    eliminarPlanOrganizacion(uuid: string) {
        return this.apiService.delete(this.apiServer + '/planesorganizacion/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.eliminarPlanOrganizacion'))
            );
    }



    /*************************************************************************************
    **DashboardIndicadorController
    **************************************************************************************/
    /**
    **DashboardIndicador
    **/
    async getDashboardIndicadoresData(): Promise<any> {
        return this.getDashboardIndicadores().toPromise();
    }
    getDashboardIndicadores() {
        return this.apiService.get(this.apiServer + '/dashboardindicadores/todos')
            .pipe(
                catchError(this.handleError('AdministracionService.getDashboardIndicadores'))
            );
    }
    
    async getDashboardIndicadoresPorDashboardData(dashboardId:number): Promise<any> {
        return this.getDashboardIndicadoresPorDashboard(dashboardId).toPromise();
    }
    getDashboardIndicadoresPorDashboard(dashboardId:number) {
        return this.apiService.get(this.apiServer + `/dashboardindicadores/${dashboardId}/dashboard`)
            .pipe(
                catchError(this.handleError('AdministracionService.getDashboardIndicadores'))
            );
    }

    async getDashboardIndicadoresPorUuidData(uuid: string): Promise<any> {
        return this.getDashboardIndicadoresPorUuid(uuid).toPromise();
    }
    getDashboardIndicadoresPorUuid(uuid: string) {
        return this.apiService.get(this.apiServer + '/dashboardindicadores/todos/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.getDashboardIndicadoresPorUuidData'))
            );
    }

    guardarDashboardIndicador(dashboardIndicador: DashboardIndicador): Observable<DashboardIndicador> {
        if (dashboardIndicador.id && dashboardIndicador.uuid) {
            return this.apiService.put(this.apiServer + '/dashboardindicadores', dashboardIndicador)
                .pipe(map(data => data['dashboardindicador']));
        } else {
            return this.apiService.post(this.apiServer + '/dashboardindicadores', dashboardIndicador)
                .pipe(map(data => data['dashboardindicador']));
        }
    }

    borrarDashboardIndicador(uuid: string): Observable<DashboardIndicador> {
        return this.apiService.delete(this.apiServer + '/dashboardindicadores/' + uuid)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarDashboardIndicador', uuid)))
    }

    borrarDashboardIndicadores(eliminarData: EliminarData): Observable<DashboardIndicador[]> {
        return this.apiService.put(this.apiServer + '/dashboardindicadores/eliminar', eliminarData)
            .pipe(
                catchError(this.handleError('AdministracionService.borrarDashboardIndicadores'))
            )
    }


}